<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" absolute fixed>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="gold">
          <v-list-item v-if="localUser && localUser.config && localUser.config.access === 'admin'" @click="$router.push({ path: '/dashboard' })">
            <v-list-item-icon ><v-icon>mdi-currency-usd</v-icon></v-list-item-icon>
            <v-list-item-title>Dashboard</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push({ path: '/users' })">
            <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
            <v-list-item-title>Users</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push({ path: '/lists' })">
            <v-list-item-icon><v-icon>mdi-format-list-bulleted</v-icon></v-list-item-icon>
            <v-list-item-title>Lists</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push({ path: '/orders' })">
            <v-list-item-icon><v-icon>mdi-cash-usd</v-icon></v-list-item-icon>
            <v-list-item-title>Orders</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push({ path: '/wallets' })">
            <v-list-item-icon><v-icon>mdi-wallet</v-icon></v-list-item-icon>
            <v-list-item-title>Wallets</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$router.push({ path: '/withdraws' })">
            <v-list-item-icon><v-icon>mdi-swap-horizontal</v-icon></v-list-item-icon>
            <v-list-item-title>Withdrawals</v-list-item-title>
          </v-list-item>
          <v-list-item @click="exit">
            <v-list-item-icon><v-icon>mdi-exit-to-app</v-icon></v-list-item-icon>
            <v-list-item-title>Exit</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Mimon - Painel Administrativo</v-toolbar-title>
    </v-app-bar>

    <router-view></router-view>

    <v-footer app>
      <span>&copy; Mimon 2022</span>
    </v-footer>
  </v-app>
</template>
<style lang="scss" scoped>
  .gold {
    color: #ffd700;
    border: 1px solid #ffd700;
  }
  aside { z-index: 2; }
</style>
<script>
import router from '@/router'
import { Auth } from 'aws-amplify'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  data: () => ({
    localUser: null,
    drawer: false,
    group: null
  }),
  created () {
    this.$vuetify.theme.dark = true
  },
  async mounted () {
    this.$store.watch(
      state => state.user,
      user => {
        this.localUser = user
        this.$store.dispatch('getLists')
        this.$store.dispatch('getOrders')
      },
      { deep: true }
    )
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    async exit () {
      try {
        await Auth.signOut()
        router.push({ path: '/login' })
      } catch {
        alert('Erro no logout, abrir historico, clicar com botao direito no site, depois em "Esquecer este site"')
      }
    }
  }
}
</script>
